export default __webpack_public_path__ + "static/media/tyt_logo.89f7a9b6.png";